import {useCredentialsStore} from "@src/Store/userStore.ts";
import {EmployeeView} from "@src/Pages/Views/Employee/AttendanceHistory/AttendanceHistoryPage.tsx";
import {ManagerView} from "@src/Pages/Views/Manager/AttendanceHistory/AttendanceHistoryPage.tsx";
import {RouteObject} from "react-router";
import {ErrorPage} from "@src/Layers/ErrorLayer/ErrorPage.tsx";
import {BackButtonViewPage} from "@src/CommonComponents/HeaderWithBackButton/HeaderWithBackButton.tsx";


export const AttendanceHistoryWrapper = () => {
    const employee = useCredentialsStore(x => x.employee)
    if (!employee) return
    if (employee?.is_manager) return <ManagerView/>
    return <EmployeeView/>
}

export const path = 'attendance-history'

export const attendanceHistoryPageRoute: RouteObject = {
    path,
    element: (
        <BackButtonViewPage
            title={"Attendance history"}
            backLink={"/check-in/"}
            showFilters={true}
        >
            <AttendanceHistoryWrapper/>
        </BackButtonViewPage>
    ),
    errorElement: <ErrorPage header={false}/>
}